// by default https://polyfill.io is included in public/index.html
// but it doesn't include these:
import 'svgxuse';
import '@babel/polyfill';



// WEBPACK FOOTER //
// ./src/polyfills.js